import * as React from "react"
import { Link } from 'gatsby'
import { useState, useRef } from "react"
import { categoryDiscover } from '@/service/api'
import { useEffect } from "react"
import categoryArrow from '@/images/category_arrow.png'
import * as cs from './category-pc.module.scss'
import SEO from '@/templates/seo'
import Loading from '@/layouts/Loading'
import ArticleItem from './ArticleItem'
import SearchProductItem from './SearchProductItemPc'

interface sort {
  label: string,
  id: null | string
}
const availableSorts: sort[] = [
  { label: '默认排序', id: null },
  { label: '销量从高到低', id: 'sales' },
  { label: '折扣从高到低', id: 'discount' },
  { label: '价格从高到低', id: 'priceDescTag' },
  { label: '价格从低到高', id: 'priceAscTag' }
]

const size = 80;

const CategoryPC = (props: any) => {
  const { suggests, products: items, keyword, total: _total, selectedWords, relatedArticles } = props || {}

  const [products, setProducts] = useState<null | Array<any>>(items)
  const [total, setTotal] = useState<null | number>(_total)
  const [sort, changeSort] = useState(availableSorts[0])
  const [from, setFrom] = useState(0)
  const [query, setQuery] = useState(keyword)
  const [searchInput, setSearchInput] = useState<string>(keyword)
  const [showLoading, setShowLoading] = useState(false)
  const [discountRange1, changeDiscountRange1] = useState<undefined | string>(undefined)
  const [discountRange2, changeDiscountRange2] = useState<undefined | string>(undefined)
  const [priceRange1, changePriceRange1] = useState<undefined | string>(undefined)
  const [priceRange2, changePriceRange2] = useState<undefined | string>(undefined)

  const discountRef1 = useRef<HTMLInputElement>(null)
  const discountRef2 = useRef<HTMLInputElement>(null)
  const discountRef3 = useRef<HTMLInputElement>(null)
  const discountRef4 = useRef<HTMLInputElement>(null)

  const priceRef1 = useRef<HTMLInputElement>(null)
  const priceRef2 = useRef<HTMLInputElement>(null)
  const priceRef3 = useRef<HTMLInputElement>(null)
  const priceRef4 = useRef<HTMLInputElement>(null)

  useEffect(() => {
    onSave()
  }, [sort])

  useEffect(() => {
    search()
  }, [from])


  const search = () => {
    setShowLoading(true)
    let q = `f=${from * size}&t=${(from + 1) * size}&q=${encodeURIComponent(searchInput || '')}`
    if (sort && sort.id) q += `&s=${sort.id}`
    if (priceRange1 && priceRange2) {
      q += `&prs=${Number(priceRange1) * 100}-${Number(priceRange2) * 100}`
    } else if (priceRange1) {
      q += `&prs=${Number(priceRange1) * 100}-`
    } else if (priceRange2) {
      q += `&prs=0-${Number(priceRange2) * 100}`
    }
    let _discountRange1 = Number(discountRange1) || 0;
    let _discountRange2 = Number(discountRange2) || 100;
    if (_discountRange1 < 0) _discountRange1 = 0
    if (_discountRange2 > 10) _discountRange2 = 10
    q += `&dr=${100 - _discountRange2 * 10}-${100 - _discountRange1 * 10}`
    categoryDiscover(q)
      .then((res: any) => {
        setShowLoading(false)
        const productList: any[] = res.products
          ?.filter((product: any) => product.type === 'PRODUCT')
          ?.slice(0, size) || []
        if (productList?.length) {
          if (from) {
            setProducts(products!.concat(productList))
          } else {
            setQuery(searchInput)
            setProducts(productList)
          } 
        }
        setTotal(res?.total)
      }).catch(err => {
        setShowLoading(false)
        console.error(err)
      })
  }


  const changeInput = (e: React.ChangeEvent<HTMLInputElement>, cb: Function, type: string) => {
    let value = e.target.value.trim()
    value = value.replace(/[^0-9.]/g, '')
    if (type === 'discount' && Number(value) > 10) {
      return
    }
    cb(value)
  }

  const onSave = () => {
    if (priceRange1 && priceRange1 !== '$' && !priceRange2) changePriceRange2('$')
    if (!priceRange1 && priceRange2 && priceRange2 !== '$') changePriceRange1('$')
    if ((!priceRange1 || priceRange1 === '$') && (!priceRange2 || priceRange2 === '$')) {
      resetPrice()
    }
    if (discountRange1 && discountRange1 !== '0折' && !discountRange2) changeDiscountRange2('全价')
    if (!discountRange1 && discountRange2 && discountRange2 !== '全价') changeDiscountRange1('0折')
    if ((!priceRange1 || priceRange1 === '0折') && (!priceRange2 || priceRange2 === '全价')) {
      resetPrice()
    }
    if (from === 0) {
      search()
    } else {
      setFrom(0)
    }
    // 加个loading
  }

  const resetDiscount = () => {
    changeDiscountRange1(undefined);
    changeDiscountRange2(undefined);
    discountRef1.current!.value = ''
    discountRef2.current!.value = ''
    discountRef3.current!.value = ''
    discountRef4.current!.value = ''
  }

  const resetPrice = () => {
    changePriceRange1(undefined);
    changePriceRange2(undefined);
    if (priceRef1.current) { priceRef1.current.value = ''; }
    if (priceRef2.current) { priceRef2.current.value = ''; }
    if (priceRef3.current) { priceRef3.current.value = ''; }
    if (priceRef4.current) { priceRef4.current.value = ''; }
  }

  function seo() {
    return (
      <SEO
        title={`[${keyword}]品牌_图片_价格_正品_怎么样 | 别样海外购`}
        description={`别样${keyword}海淘频道，别样海外购是一个欧美奢品海外直购的电商平台，提供正品${selectedWords.join(',')}等导购信息，包含潮牌，男士，时尚，美妆，母婴，健康，时尚，家具生活，珠宝首饰，男女鞋靴，潮玩数码等分类频道`}
        keywords={`${keyword}, ${selectedWords?.join(',')}`}
      />
    )
  }

  const onQueryInputChange = (e: any) => {
    const value = e.target.value.trim()
    setSearchInput(value)
  }

  const onSearch = () => {
    if (from === 0) {
      search()
    } else {
      setFrom(0)
    }
  }

  return (
    <div className={cs.category}>
      {showLoading && <Loading />}
      {seo()}
      <div className={cs.categoryStep}>
        <span>
          <a href='/'><span>首页</span></a>
          <img className={cs.categoryStepArrow} src={categoryArrow} />
        </span>
        <span>
          <a href='#'><span>{keyword}</span></a>
        </span>
      </div>
      <div className={cs.searchNav}>
        {/* <h1 className={cs.categoryTitle}>{keyword}</h1> */}
        <div className={cs.searchBarWrapper}>
          <input onChange={onQueryInputChange} value={searchInput} className={cs.searchBar} type="text" name="keyword" placeholder={keyword} autoComplete="off" />
          <div className={cs.searchBarBtn} onClick={onSearch}>搜索</div>
        </div>
      </div>
      <div className={cs.categoryBar}>
        <div className={cs.categoryBarLeft}>
          <div className={cs.categoryBarLeftSort}>
            <span className={cs.categoryBarLeftSortText}>{sort.label}</span>
            <div className={cs.categoryBarLeftSortHoverBg}>
              <ul className={cs.categoryBarLeftSortHover}>
                {
                  availableSorts.map((item: sort) => {
                    return (
                      <li
                        key={item.label}
                        className={sort.label === item.label ? cs.categoryBarLeftSortHoverCurrent : ''}
                        onClick={() => { changeSort(item) }}
                      >
                        {item.label}
                      </li>
                    )
                  })
                }
              </ul>
            </div>
          </div>
          <div className={cs.categoryBarLeftPrice}>
            <span>价格：</span>
            <input ref={priceRef1} type="text" name="最小价格" placeholder='$' value={priceRange1} autoComplete='off' />
            <span className={cs.categoryBarLeftPriceLine}></span>
            <input ref={priceRef2} type="text" name="最高价格" placeholder='$' value={priceRange2} autoComplete="off" />
            <div className={cs.categoryBarLeftPriceHover}>
              <div className={cs.categoryBarLeftPriceHoverTop}>
                <span>价格：</span>
                <input ref={priceRef3} type="text" name="最小价格" placeholder='$' value={priceRange1}
                  onChange={(e) => { changeInput(e, changePriceRange1, 'price') }}
                  autoComplete="off" />
                <span className={cs.categoryBarLeftPriceLine}></span>
                <input ref={priceRef4} type="text" name="最高价格" placeholder='$' value={priceRange2}
                  onChange={(e) => { changeInput(e, changePriceRange2, 'price') }}
                  autoComplete="off" />
              </div>
              <div className={cs.categoryBarLeftPriceHoverBtns}>
                <span onClick={resetPrice}>清除</span><span onClick={onSave}>确定</span>
              </div>
            </div>
          </div>
          <div className={cs.categoryBarLeftDiscount}>
            <span>折扣：</span>
            <input ref={discountRef1} type="text" name='最低折扣' placeholder='0折' value={discountRange1 && discountRange1 !== '0折' ? discountRange1 + '折' : discountRange1} autoComplete="off" />
            <span className={cs.categoryBarLeftDiscountLine}></span>
            <input ref={discountRef2} type="text" name='最高折扣' placeholder='全价' value={discountRange2 && discountRange2 !== '全价' ? discountRange2 + '折' : discountRange2} autoComplete="off" />
            <div className={cs.categoryBarLeftDiscountHover}>
              <div className={cs.categoryBarLeftDiscountHoverTop}>
                <span>折扣：</span>
                <input maxLength={3} ref={discountRef3} type="text" name='最低折扣' placeholder='0折' value={discountRange1}
                  onChange={(e) => { changeInput(e, changeDiscountRange1, 'discount') }}
                  autoComplete="off" />
                <span className={cs.categoryBarLeftDiscountLine}></span>
                <input maxLength={3} ref={discountRef4} type="text" name='最高折扣' placeholder='全价' value={discountRange2}
                  onChange={(e) => { changeInput(e, changeDiscountRange2, 'discount') }}
                  autoComplete="off" />
              </div>
              <div className={cs.categoryBarLeftDiscountHoverBtns}>
                <span onClick={resetDiscount}>清除</span><span onClick={onSave}>确定</span>
              </div>
            </div>
          </div>
        </div>
        <div className={cs.categoryBarRight}><h1 className={cs.searchBarKeyword}>{query}</h1>, 共{total}件商品</div>
      </div>
      <section className={cs.categorySection}>
        {
          products?.map((item: any, idx: number) => {
            return (
              <SearchProductItem keyword={keyword} item={item} key={idx} />
            )
          })
        }
      </section>
      <div className={cs.categoryLoadMore} onClick={() => setFrom(from + 1)}>查看更多</div>
      {
        relatedArticles?.length ? (
          <section>
            <div className={cs.searchRelatedArticlesTitle}>相关文章</div>
            <div className={cs.searchRelatedArticles}>
              {relatedArticles.map((article: any, index: number) => {
                return (
                  <ArticleItem article={article} index={index} />
                )
              })}
            </div>
          </section>
        ) : null
      }
      {
        suggests?.length ? (
          <div className={cs.searchMoreKeywords}>
            <div className={cs.searchMoreKeywordsTitle}>相关搜索</div>
            <div className={cs.searchMoreKeywordsList}>
              {suggests?.map((s: any, index: number) => {
                return (
                  <a title={s.keyword} key={index} href={`/browse/${s.pathname}/`}>
                    <div>{s.keyword}</div>
                  </a>
                )
              })}
            </div>
          </div>
        ) : null
      }
    </div>
  )
}

export default CategoryPC
